import { useState } from "react";
import { Link } from "react-router-dom";
import { useAdminDocuments } from "../../hooks/use-admin.js";
import { PageSkeleton } from "../../components/skeleton.js";

const LIMIT = 30;

function pacBadgeClass(pacStatus: string | null): string {
  switch (pacStatus) {
    case "pass":
      return "run-badge run-badge--success";
    case "fail":
      return "run-badge run-badge--failed";
    case "warning":
      return "run-badge run-badge--partial";
    default:
      return "run-badge run-badge--idle";
  }
}

export function AdminDocumentsPage() {
  const [page, setPage] = useState(1);
  const { data, isLoading } = useAdminDocuments({ page, limit: LIMIT });

  if (isLoading) return <PageSkeleton />;

  return (
    <div className="product-page">
      <h1 className="page-title">Document Scans</h1>
      {data && (
        <>
          <table className="admin-table text-sm">
            <thead>
              <tr>
                <th>Website</th>
                <th className="text-right">Detected</th>
                <th className="text-right">Scanned</th>
                <th className="text-right">Failed</th>
                <th className="text-right">Findings</th>
                <th>PAC Status</th>
                <th>Completed</th>
              </tr>
            </thead>
            <tbody>
              {data.documents.map((doc) => (
                <tr key={doc.documentRunId}>
                  <td>
                    <Link to={`/admin/websites/${doc.websiteId}`}>
                      {doc.websiteUrl}
                    </Link>
                  </td>
                  <td className="text-right">{doc.documentsDetected}</td>
                  <td className="text-right">{doc.documentsScanned}</td>
                  <td className="text-right">
                    {doc.documentsFailed > 0 ? (
                      <span className="text-danger">
                        {doc.documentsFailed}
                      </span>
                    ) : (
                      0
                    )}
                  </td>
                  <td className="text-right">{doc.findingsCount}</td>
                  <td>
                    {doc.pacStatus ? (
                      <span className={pacBadgeClass(doc.pacStatus)}>
                        {doc.pacStatus}
                      </span>
                    ) : (
                      <span className="text-muted">&mdash;</span>
                    )}
                  </td>
                  <td>
                    {doc.completedAt
                      ? new Date(doc.completedAt).toLocaleString("en-IE")
                      : <span className="text-muted">&mdash;</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.documents.length === 0 && (
            <p className="text-muted text-center py-2">
              No document scans found.
            </p>
          )}
          <div className="d-flex items-center gap-2 mt-3">
            <button
              className="btn btn--secondary btn--sm"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              Previous
            </button>
            <span className="text-sm">
              Page {page} &middot; {data.total} total
            </span>
            <button
              className="btn btn--secondary btn--sm"
              onClick={() => setPage((p) => p + 1)}
              disabled={data.documents.length < LIMIT}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}
